<template>
  <div class="settle-account-row">
    <div class="settle-account-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        height="300"
        @edit-actived="editActivedEvent"
        @edit-closed="closeEditTableHandler"
      >
        <!-- @edit-closed="closeEditTableHandler" -->

        <template v-slot:buttons>
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新增</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.editRender.name == 'expenseType'">{{
              serviceExpenseList?.find((item) => item.value == row['expenseType'])?.label
            }}</span>
            <span v-else-if="item.editRender.name == 'unit'">{{
              row['unitList'].find((item) => item.unitNo == row['unit'])?.unitName
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <!-- 费用类型 -->
            <el-select
              v-if="item.editRender.name == 'expenseType'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) in serviceExpenseList"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
            <!-- 结算单价(含税) -->
            <el-input-number
              :precision="3"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'originalPrice'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 结算数量 -->
            <el-input-number
              :precision="3"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'statementQuantity'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 计量单位 -->
            <el-select
              v-if="item.editRender.name == 'unit'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) of row.unitList"
                :key="index"
                :value="item.unitNo"
                :label="item.unitName"
              ></el-option>
            </el-select>
            <!-- 结算金额(含税) -->
            <el-input-number
              :precision="2"
              :min="null"
              :controls="false"
              disabled
              v-if="item.editRender.name == 'originalAmount'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 备注 -->
            <el-input
              v-if="item.editRender.name == 'remark'"
              v-model="row[item.field]"
              maxlength="50"
              @input="() => handleChange(row, item.field)"
            ></el-input>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <IPagination
        :total="tableTotal"
        :multipleSelection="selectionList"
        @changePageHandler="changePageHandler"
      />
    </div>
  </div>
</template>

<script>
  import { tableColumnList, tableRules } from './index.js';
  // import BASEAPI from '@/api/dataBase.js';
  import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';
  import expenseListMixin from '../../../../index.js';
  export default {
    mixins: [expenseListMixin],
    name: 'NoSurchargeRow',
    props: {
      selectInstructionDetailList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        serviceExpenseList: [],

        tableTotal: 0,
        selectionList: [],
        tableData: [],
        tableRules,
        tableColumnList,
        isFetchTableData: false,
      };
    },
    computed: {
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      tableStatus() {
        return ['detail', 'edit'].includes(this.$route.query.status) ? this.linesData.length : true;
      },
    },
    methods: {
      updateExpenseList() {
        const $table = this.$refs.settleAccountsRef;
        // 获取表格中的全量数据
        const { fullData } = $table.getTableData();
        this.serviceExpenseList.forEach((item) => {
          if (item.value) {
            // 如果当前选项已经被选过，则禁用
            item.disabled = fullData.some((row) => row.expenseType === item.value);
          }
        });
      },
      editActivedEvent({ row }) {
        console.log(row, 'row');
        // 激活编辑时检查剩余选项是否可选择
        this.updateExpenseList();
      },
      // 根据服务类型获取费用类型
      async getExpenseList() {
        console.log('搜索', this.selectInstructionDetailList[0].orderServiceType);
        let postData = {
          serviceNo: this.selectInstructionDetailList[0].orderServiceType,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.SERVICE_EXPENSELISTS_API,
          postData
        );
        if (data.code == 0) {
          if (data.data.length) {
            data.data.map((item) => {
              this.serviceExpenseList.push({
                label: item.expenseName,
                value: item.expenseNo,
                unit: item.typeUnits,
                disabled: false,
              });
            });
          }
        }
        console.log(data, '根据服务类型获取费用类型');
        // this.tableData = data?.data?.records;
        // this.tableData = tableList;
        // this.multipleSelection = []; //初始化选中数据
        // this.$refs.siruiTable.setPageTotal(data?.data?.total);
      },
      async validAllEvent() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
          return true;
        } else {
          return false;
        }
      },

      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
      },
      // 新增行
      async newRowHandler() {
        console.log(this.selectInstructionDetailList, 'this.selectInstructionDetailList');
        //先获取订单  指令单 服务类型
        let {
          instructCode,
          orderServiceType,
          orderCode,
          contractCode,
          customerName,
          customerNo,
          productType,
          productTypeName,
          orderServiceTypeName,
          instructIssueDate,
          createdByName,
          createBy,
          projectCode,
          projectName,
          orderCompletedDate,
          businessDepartmentName,
          businessDepartmentCode,
          platformCompanyNo,
          platformCompanyName,
        } = this.selectInstructionDetailList[0];
        let rowData = {
          orderCode,
          instructionNo: instructCode,
          businessDocCode: instructCode,
          serviceType: orderServiceType,
          productTypeName,
          serviceTypeName: orderServiceTypeName,
          businessCategory: '02',
          businessCompanyName: platformCompanyName,
          businessCompanyNo: platformCompanyNo,
          businessDepartmentName,
          businessDepartmentCode,
          // businessCompanyName: this.businessCompanyName,
          // businessCompanyNo: this.query.businessCompanyNo,
          // businessDepartmentName: this.businessDepartmentName,
          // businessDepartmentCode: this.query.businessDepartmentCode,
          contractNo: contractCode,
          customerName,
          customerNo,
          productType,
          accountPeriod: orderCompletedDate ? orderCompletedDate.slice(0, 7) : '',
          instructionIssueDate: instructIssueDate,
          salesmanName: createdByName,
          salesmanNo: createBy,
          abnormalExpenseFlag: '0',
          createMethod: '02',
          projectInitiationNo: projectCode,
          projectName,
          unitList: [],
        };
        this.insertEvent(rowData, 0);
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
        // console.log(this.getTableData(), 'getTableData');
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const xIDList = this.selectionList.map((item) => item._XID);
        this.tableData = this.getTableData().filter((item) => !xIDList.includes(item._XID));
        this.selectionList = [];
      },

      handleSelectionChange({ row }) {
        this.selectionList = [row];
        console.log(this.selectionList, 'this.selectionList');
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        if (field === 'expenseType') {
          this.updateExpenseList();
          row['expenseTypeName'] = this.serviceExpenseList?.find(
            (item) => item.value == row['expenseType']
          )?.label;
          row['unitList'] = this.serviceExpenseList?.find(
            (item) => item.value == row['expenseType']
          )?.unit;
        } else if (field === 'originalPrice') {
          row['originalAmount'] =
            +(row['originalPrice'] * row['statementQuantity']).toFixed(2) || '';
        } else if (field === 'statementQuantity') {
          row['originalAmount'] =
            +(row['originalPrice'] * row['statementQuantity']).toFixed(2) || '';
        } else if (field === 'unit') {
          row['unitName'] = row['unitList'].find((item) => item.unitNo == row['unit'])?.unitName;
        }
      },
      async closeEditTableHandler() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查数据再提交');
        } else {
          // 派发事件

          const tableData = this.getTableData();
          this.tableData = tableData;
        }
      },

      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table.getTableData().fullData;
      },
      // 修改明细表中反填表格数据到表中
      fullTableData(val) {
        console.log(val, '修改明细反填');
        if (!val) return;
        console.log(this, '------>>');
        const tableData = this.getTableData();
        const {
          _XID,
          __deduction,
          domesticAmount,
          originalAmount,
          originalPrice,
          statementQuantity,
          unit,
        } = val;
        if (__deduction) {
          console.log('11111');
          // 抵扣的时候，并且判重复
          const isExist = tableData.find((item) => item.__deduction == val.__deduction);
          if (!isExist) {
            this.tableData.push(val);
          }
        } else {
          this.tableData = tableData.map((item) => {
            if (item._XID == _XID) {
              return {
                ...item,
                domesticAmount,
                originalAmount,
                originalPrice,
                statementQuantity,
                unit,
              };
            } else {
              return item;
            }
          });
        }

        // 处理结算明细数据变动更新表单
        this.$emit('closeEditTableHandler', this.tableData);
      },

      // 反填远程返回的数据
      fullFetchTableData(val) {
        // 只需要处理一次,采用查重数组或者定义一个变量方式处理
        if (!this.isFetchTableData) {
          this.$nextTick(() => {
            if (val.length > 0) {
              val.forEach((item) => {
                item.additional = item.additional == 1 ? true : false;
              });
            }
            const $table = this.$refs.settleAccountsRef;
            console.log(val, '查看');
            // for (let i = 0; i < val.length; i++) {
            //   $table?.insertAt(val[i], i);
            // }
            $table?.insertAt(val, 0);
            // this.tableData = val;
            this.isFetchTableData = true;
            // 处理反填的时候结算明细表
            this.$emit('closeEditTableHandler', this.getTableData(), true);
            //当第一个结算行有明细时默认显示
            if (val[0].lineDetails) {
              this.$emit('selectionRowHandler', this.getTableData()[0]);
            }
          });
        }
      },
    },
    mounted() {
      this.getExpenseList();
    },
    watch: {
      // currentDetailData: {
      //   handler(val) {
      //     this.fullTableData(val);
      //   },
      //   // immediate: true,
      //   deep: true,
      // },
      // linesData: {
      //   handler(val) {
      //     if (val && Array.isArray(val) && val.length) {
      //       this.fullFetchTableData(val);
      //     }
      //   },
      //   immediate: true,
      //   deep: true,
      // },
    },
  };
</script>

<style lang="scss" scoped>
  .settle-account-row {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
